// extracted by mini-css-extract-plugin
export default {"body":"AnnotatorTagNameModal-module__body--e9917","footer":"AnnotatorTagNameModal-module__footer--b0f80"};